export default __webpack_public_path__ + "static/feature-3-7e6dff9a788e658ba8f2dae2788911da.png";